var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrivacy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7065_92802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4688 19.3047H20.2812",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4688 15.3984H20.2812",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2812 5.63281H25.1641C25.4231 5.63281 25.6715 5.7357 25.8546 5.91884C26.0377 6.10198 26.1406 6.35037 26.1406 6.60938V27.1172C26.1406 27.3762 26.0377 27.6246 25.8546 27.8077C25.6715 27.9909 25.4231 28.0938 25.1641 28.0938H7.58594C7.32694 28.0938 7.07854 27.9909 6.8954 27.8077C6.71226 27.6246 6.60938 27.3762 6.60938 27.1172V6.60938C6.60938 6.35037 6.71226 6.10198 6.8954 5.91884C7.07854 5.7357 7.32694 5.63281 7.58594 5.63281H12.4688",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4922 9.53906V8.5625C11.4922 7.2675 12.0066 6.02554 12.9223 5.10983C13.838 4.19413 15.08 3.67969 16.375 3.67969C17.67 3.67969 18.912 4.19413 19.8277 5.10983C20.7434 6.02554 21.2578 7.2675 21.2578 8.5625V9.53906H11.4922Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7065_92802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.25,
    height: 31.25,
    fill: "white",
    transform: "translate(0.75 0.75)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.60ec80d3.svg";
export { ForwardRef as ReactComponent };